import { render, staticRenderFns } from "./ApprovalModal.vue?vue&type=template&id=0d8bd0f4"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalModal.vue?vue&type=style&index=0&id=0d8bd0f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports